import { useFeatureFlagsContext } from '../context/FeatureFlagsContext';
import type { FeatureFlagName } from '../types';

interface UseFeatureFlagResult {
  enabled: boolean;
  isLoading: boolean;
}

export function useFeatureFlag(name: FeatureFlagName | string): UseFeatureFlagResult {
  const { flags, isLoading } = useFeatureFlagsContext();
  return {
    enabled: flags[name] ?? false,
    isLoading,
  };
}
